var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "bigTraffic" },
    [
      _c(
        "div",
        { staticClass: "firstLine" },
        [
          _vm._l(_vm.bigTrafficTypes, function (item, index) {
            return _c(
              "span",
              {
                key: index,
                staticClass: "title",
                style: _vm.checkType != index ? "background: #e4ab97;" : "",
                on: {
                  click: function ($event) {
                    _vm.checkType = index
                  },
                },
              },
              [_vm._v(_vm._s(item.stateName))]
            )
          }),
          _c(
            "el-radio",
            { staticStyle: { "margin-left": "0.3rem" }, attrs: { label: "1" } },
            [_vm._v("单程")]
          ),
          _c("el-radio", { attrs: { label: "2" } }, [_vm._v("往返")]),
          _c("el-radio", { attrs: { label: "3" } }, [_vm._v("多程(含缺口程)")]),
        ],
        2
      ),
      _c("div", { staticClass: "searchDiv" }, [
        _c("div", { staticClass: "inputDiv" }, [
          _c("div", { staticClass: "left" }, [
            _c(
              "p",
              [
                _vm._v(" 出发城市："),
                _c("el-input", {
                  staticStyle: { width: "2rem" },
                  attrs: { placeholder: "带入当天的第一个城市", size: "mini" },
                }),
              ],
              1
            ),
            _c(
              "p",
              [
                _vm._v(" 抵达城市："),
                _c("el-input", {
                  staticStyle: { width: "2rem" },
                  attrs: { placeholder: "带入当天的第一个城市", size: "mini" },
                }),
              ],
              1
            ),
          ]),
          _vm._m(0),
          _c(
            "div",
            { staticClass: "right", staticStyle: { "margin-left": "0.15rem" } },
            [
              _c(
                "p",
                [
                  _vm._v(" 出发日期："),
                  _c("el-date-picker", {
                    attrs: {
                      type: "date",
                      placeholder: "选择日期",
                      size: "mini",
                    },
                  }),
                ],
                1
              ),
              _c(
                "p",
                [
                  _vm._v(" 返程日期："),
                  _c("el-date-picker", {
                    attrs: {
                      type: "date",
                      placeholder: "选择日期",
                      size: "mini",
                    },
                  }),
                ],
                1
              ),
            ]
          ),
        ]),
        _c(
          "div",
          { staticClass: "selectDiv" },
          [
            _vm._v(" 仓位等级： "),
            _c("el-input", {
              staticStyle: { width: "1rem" },
              attrs: { placeholder: "儿童", size: "mini" },
            }),
            _c("el-input", {
              staticStyle: { width: "1rem" },
              attrs: { placeholder: "儿童", size: "mini" },
            }),
            _c("el-input", {
              staticStyle: { width: "1rem" },
              attrs: { placeholder: "儿童", size: "mini" },
            }),
            _c("span", { staticClass: "searchBtn" }, [_vm._v("搜 索")]),
          ],
          1
        ),
      ]),
      _c("div", { staticClass: "btnDiv" }, [
        _c("div", { on: { click: _vm.addTraffic } }, [
          _vm._v("添加自行采购的交通产品"),
        ]),
        _c("div", [_vm._v("向众多票代一键询价")]),
      ]),
      _c("add-big-traffic", { ref: "addBigTraffic" }),
    ],
    1
  )
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "middle" }, [
      _c("p", { staticClass: "top" }),
      _c("p", { staticClass: "font" }, [_vm._v("换")]),
      _c("p", { staticClass: "button" }),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }